<div class="ui-g ui-fluid">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <div class="ui-g-12 ui-md-12 ui-lg-12" style="background-color:#F5F5F5;">
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <form #campaignNameCreation="ngForm" name="campaignNameForm" id="campaignNameForm" (ngSubmit)="campaignOnGoalSubmit(campaignNameCreation.value)" autocomplete="off">
            <input type="text" #campNm data-testid="campNm" name="campaignName" required="" [(ngModel)]="campaignName" style="border: 0px;outline: 0px;border-bottom: 1px solid #CBCBCB;background-color: #F5F5F5;width:80%" />
            <i class="fa fa-pencil" aria-hidden="true" style="margin-left: -3%; color: #4A4A4A;"></i>
            <input type="submit" name="s" #formSubmission data-testid="formSubmission" value="submit" style="visibility:hidden;">
          </form>
        </div>
        <div class="ui-g-12 ui-md-3 ui-lg-3"></div>
        <div class="ui-g-12 ui-md-3 ui-lg-3" [ngClass]="{selectedStep : type=='budget'}" (click)="nextCampaignStep('save')" style="color:#80807F;background-color:#1D1D1B;border-radius: 15px;text-align: center;cursor:pointer;">
          SAVE AND EXIT
        </div>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12" style="background-color:#1D1D1B;">
        <div class="ui-g-4 ui-md-2 ui-lg-2" [ngClass]="{selectedStep : type=='goal'}" style="color:#8D8D8C;">1.Goal</div>
        <div class="ui-g-4 ui-md-2 ui-lg-2" [ngClass]="{selectedStep : type=='master'}" style="color:#8D8D8C;">2.Settings</div>
        <div class="ui-g-4 ui-md-2 ui-lg-2" [ngClass]="{selectedStep : type=='budget'}" style="color:#8D8D8C;">3.Budget</div>
        <div class="ui-g-4 ui-md-2 ui-lg-2" [ngClass]="{selectedStep : type=='focusOnCustomer'}" style="color:#8D8D8C;">4.Targeting</div>
        <div class="ui-g-4 ui-md-2 ui-lg-2" [ngClass]="{selectedStep : type=='focusOnCustomer'}" style="color:#8D8D8C;">5.Coupons recap</div>
        <div class="ui-g-4 ui-md-1 ui-lg-1" [ngClass]="{selectedStep : type=='focusOnCustomer'}" *ngIf="type !='goal'" style="color: #FFF;background-color: #5C5C5B;border-radius: 15px;text-align: center;cursor:pointer;" (click)="previousCampaignStep()">BACK</div>
        <div class="ui-g-4 ui-md-1 ui-lg-1" [ngClass]="{selectedStep : activityType!=100}" *ngIf="type !='budget'" style="color: #8D8D8C;background-color: #5C5C5B;border-radius: 15px;text-align: center;cursor:pointer;" (click)="nextCampaignStep('next')">NEXT</div>
      </div>
      <div class="ui-g-12 ui-md-6 ui-lg-6">
        <span *ngIf="type=='goal'"><strong>{{ 'campaign.createCampaign' | translate }}!</strong></span>
        <span *ngIf="type=='master'"><strong>{{ 'campaign.stepDesc2' | translate }}.</strong></span>
        <span *ngIf="type=='budget'"><strong>{{ 'campaign.defineBudget' | translate }}.</strong></span>
      </div>
      <div class="ui-g-12 ui-md-6 ui-lg-6" style="text-align:right;">
        {{ 'campaign.statusCreation' | translate }}
      </div>
      <!-- Goal starts -->
      <div class="goal" *ngIf="type=='goal'">
        <div class="ui-g-12 ui-md-6 ui-lg-6 goals">
          <div class="goalLabel">{{ 'campaign.selectBusinessGoal' | translate }}</div>
          <div *ngFor="let eachGoal of result; let i=index" class="eachGoal" (click)="goalType=i;activityType=100" [ngClass]="{selectedEachGoal : goalType==i}">
            <div class="ui-g-6 ui-md-6 ui-lg-2 iconStyle">
              <i class="fa fa-users fontStyle" *ngIf="i==0" aria-hidden="true"></i>
              <i class="fa fa-map-marker fontStyle" *ngIf="i==1" aria-hidden="true"></i>
              <i class="fa fa-shopping-bag fontStyle" *ngIf="i==2" aria-hidden="true"></i>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-10 eachGoalLabel">
              <strong>{{eachGoal.focusName}}</strong>
              <i *ngIf="goalType==i" class="fa fa-angle-right rightArrowStyle" aria-hidden="true"></i>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6" style="border-top:1px solid #F5F5F5;">
          <div class="activityLabel" *ngIf="result.length != 0">{{ 'campaign.selectActivity' | translate }}</div>
          <div class="activity" *ngIf="result.length != 0">
            <div class="eachActivity" *ngFor="let eachActivity of result[goalType]['targetModel']; let i=index" [ngClass]="{selectedActivity : activityType==i}" (click)="activityType=i;activityChoose(eachActivity,$event)">
              {{eachActivity.targetName}}
              <i class="fa fa-info-circle rightArrowStyle" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- Goal Ends -->
      <!-- Master Starts -->
      <div class="master" style="background-color:#F5F5F5;color: #636363;" *ngIf="type=='master'">
        <form #settingsForm="ngForm" id="settingsCreation" name="settingsCreation" (ngSubmit)="campaignOnMasterSubmit(settingsForm.value)" autocomplete="off">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <h3>Master Data</h3>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.campaignType' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12 ui-md-3 ui-lg-4" *ngFor="let eachCampaignType of campaignTypeModel">
                <p-radioButton name="campaignTypeCode" [(ngModel)]="campaignTypeCode" value="{{eachCampaignType.value}}" label="{{eachCampaignType.name}}" required=""></p-radioButton>
              </div>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.campaignPriority' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-selectButton [options]="priorityTypes" name="campaignPriorityCode" [(ngModel)]="campaignPriorityCode"></p-selectButton>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.bypassCustomerPressureRules' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-6 ui-md-3 ui-lg-3" *ngFor="let bypassCustomer of bypassCustomerRulesModel">
                <p-radioButton name="flagCustomerPressureRule" required="" [(ngModel)]="flagCustomerPressureRule" value="{{bypassCustomer.value}}" label="{{bypassCustomer.name}}"></p-radioButton>
              </div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <h3>Channel Data</h3>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.channel' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12 ui-md-6 ui-lg-4" *ngFor="let channel of channelResult; let i=index">
                <p-radioButton name="channelCode" required="" [(ngModel)]="selectedChannels" value="{{channel.value}}" label="{{channel.name}}"></p-radioButton>
              </div>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.emission' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6">
              Start Date
              <p-calendar [(ngModel)]="emissionStartDate" name="emissionStartDate" required="" readonlyInput="readonlyInput" [showIcon]="true" placeholder="Start Date" dataType="date" dateFormat="{{'pcalendar.dateFormat' | translate}}" readonlyInput="" (onSelect)="setEmissionEndDate($event)" [locale]="srvCalTranslate.pcalendarTranslate"></p-calendar>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6">
              End Date
              <p-calendar [(ngModel)]="emissionEndDate" name="emissionEndDate" required="" readonlyInput="readonlyInput" [showIcon]="true" placeholder="End Date" readonlyInput="" dateFormat="{{'pcalendar.dateFormat' | translate}}" [locale]="srvCalTranslate.pcalendarTranslate"></p-calendar>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              {{'campaign.redemption' | translate}}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6">
              Start Date
              <p-calendar [(ngModel)]="redemptionStartDate" name="redemptionStartDate" required="" readonlyInput="readonlyInput" [showIcon]="true" dataType="date" dateFormat="{{'pcalendar.dateFormat' | translate}}" placeholder="{{'campaign.startDate' | translate}}" readonlyInput="" (onSelect)="setRedemptionEndDate($event)"
                [locale]="srvCalTranslate.pcalendarTranslate"></p-calendar>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6">
              End Date
              <p-calendar [(ngModel)]="redemptionEndDate" name="redemptionEndDate" required="" readonlyInput="readonlyInput" [showIcon]="true" dateFormat="{{'pcalendar.dateFormat' | translate}}" readonlyInput="" placeholder="{{'campaign.endDate' | translate}}" [locale]="srvCalTranslate.pcalendarTranslate"></p-calendar>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12 ui-md-2 ui-lg-2">
                <p-inputSwitch name="flagOpenRedemptionPeriod" [(ngModel)]="flagOpenRedemptionPeriod"></p-inputSwitch>
              </div>
              <div class="ui-g-12 ui-md-10 ui-lg-10">
                {{'campaign.theRedemptionPeriodIsOpen' | translate}}
              </div>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12 ui-md-2 ui-lg-2">
                <p-inputSwitch name="flagOnlyLoyaltyCard" [(ngModel)]="flagOnlyLoyaltyCard"></p-inputSwitch>
              </div>
              <div class="ui-g-12 ui-md-10 ui-lg-10">
                {{'campaign.cardHolderLabel' | translate}}
              </div>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12 ui-md-2 ui-lg-2">
                <p-inputSwitch name="flagOnlyCardHolder" [(ngModel)]="flagOnlyCardHolder"></p-inputSwitch>
              </div>
              <div class="ui-g-12 ui-md-10 ui-lg-10">
                {{'campaign.loyaltyCardLabel' | translate}}
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <input type="submit" name="settings" #settingsFormSubmission data-testid="settingsFormSubmission" value="submit" style="visibility:hidden;">
        </form>
      </div>
      <!-- Master Ends -->
      <!-- Budget Ends -->
      <div *ngIf="type=='budget'">
        <form #campaignBudgetCreation="ngForm" id="campaignBudgetCreation" (ngSubmit)="campaignOnBudgetSubmit(campaignBudgetCreation.value)" autocomplete="off">
          <div class="ui-grid-row">
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <label for="input">{{'campaign.budgetAmount' | translate}}</label>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6" style="position:relative;">
              <input id="input" type="number" min="0" name="budget" required="required" [(ngModel)]="budget" pInputText [ngClass]="{redBorderBottom : showBudgetError==1}" (change)="setMinimumPercentage($event)" />
              <span class="text-right" style="position: absolute;margin-top: -4.1%;margin-left: 91.5%;">€</span>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div *ngIf="showBudgetError" class="ui-message ui-messages-error ui-corner-all">
                <i class="fa fa-close"></i>
                <span>{{budgetErrorText}}</span>
              </div>
            </div>
          </div>
          <div class="ui-grid-row text-center">
            <div class="ui-g-12 ui-md-4 ui-lg-4" *ngFor="let eachBudget of budgetResult; let i=index">
              <div class="ui-g-12">
                <label for="slider">{{eachBudget.name}}</label>
              </div>
              <div class="ui-g-12 ui-md-3 ui-lg-3">
                <input type="number" pInputText [(ngModel)]="eachBudget.amount" name="budgetAmountArr_{{i}}" readonly class="text-center" />
                <input type="hidden" pInputText [(ngModel)]="eachBudget.budgetId" name="budgetIdArr_{{i}}" readonly class="text-center" />
                <span class="percentage">%</span>
              </div>
              <div class="ui-g-12 ui-md-12 ui-lg-12">
                <p-slider [(ngModel)]="eachBudget.amount" name="budgetAmountSliderArr_{{i}}" [min]="eachBudget.min" [max]="100" [style]="{'margin-top':'10px'}" (onSlideEnd)="handleChange(i,$event)"></p-slider>
                <div class="ui-g-12 slider-percentage-container">
                  <div *ngFor="let eachVal of rangeSliderDivision; let i=index" class="ui-g-2 ui-md-2 {{rangeSliderClasses[i]}}">{{eachVal}}%</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ui-grid-row text-center">
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div *ngIf="showBudgetValoreError" class="ui-message ui-messages-error ui-corner-all">
                <i class="fa fa-close"></i>
                <span>{{budgetErrorValore}}</span>
              </div>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div *ngIf="showBudgetPercentualeError" class="ui-message ui-messages-error ui-corner-all">
                <i class="fa fa-close"></i>
                <span>{{budgetErrorPercentuale}}</span>
              </div>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div *ngIf="showBudgetPuntiError" class="ui-message ui-messages-error ui-corner-all">
                <i class="fa fa-close"></i>
                <span>{{budgetErrorPunti}}</span>
              </div>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div *ngIf="showBudgetRangeError" class="ui-message ui-messages-error ui-corner-all">
                <i class="fa fa-close"></i>
                <span>{{budgetRangeErrorText}}</span>
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <label for="input">{{'campaign.budgetNotes' | translate}}</label>
            </div>
            <div class="ui-g-12 ui-md-10 ui-lg-10">
              <textarea autoresize="autoResize" name="notes" [(ngModel)]="notes" pinputtextarea="" ng-reflect-auto-resize="autoResize" ng-reflect-rows="3" ng-reflect-cols="30" class="ui-inputtext ui-corner-all ui-state-default ui-widget" rows="6" cols="30"></textarea>
            </div>
          </div>
          <div class="clearfix"></div>
          <input type="submit" name="settings" #budgetFormSubmission data-testid="budgetFormSubmission" value="submit" style="visibility:hidden;">
        </form>
      </div>
      <!-- Budget Ends-->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/newcampaign/changecampaign.component.html